import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'normalize.css/normalize.css'
import '@/assets/css/index.less' // global css
import './assets/element/element-ui';
import './assets/icons/index' // svg-icon
import "@/assets/iconfont/iconfont.css";

// import '../mock/mock.js';

import * as util from "./utils/util.js"
Vue.prototype.$util = util
Vue.prototype.resetForm = util.resetForm

import {constants}from "@/views/datavisual/widget/index.js"
Vue.prototype.dvContants = constants

// 引入echarts
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts;

// 注册组件
import components from './components/index.js'
Vue.use(components)
import components2 from './views/datavisual/components/index.js'
Vue.use(components2)

// 自定义指令
import directive from './directive'
Vue.use(directive)

// 字典数据组件
import DictData from './components/DictData'
DictData.install()

// 对话框组件等
import Modal from './components/Modal/index.js'
Vue.prototype.$modal = Modal

// PageLayout组件
import PageLayout from './layout/PageLayout'
Vue.component('PageLayout', PageLayout)

// PageFooter组件
import PageFooter from './layout/PageFooter'
Vue.component('PageFooter', PageFooter)

// dataV组件
import dataView from '@jiaminghi/data-view'
console.log("-----注册了组件：dataView----");
Vue.use(dataView)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
